export const tableConfig = {
    unit: [
        {
            name: "kodeVariant",
            label: "Kode Varian",
            options: {
                sort: false,
            },
        },
        {
            name: "namaVariant",
            label: "Nama Varian",
            options: {
                sort: false,
            },
        },
        {
            name: "kodeWarna",
            label: "Kode Warna",
            options: {
                sort: false,
            },
        },
        {
            name: "namaWarna",
            label: "Nama Warna",
            options: {
                sort: false,
            },
        },
        {
            name: "segmenName",
            label: "Segmen",
            options: {
                sort: false,
            },
        },
        {
            name: "namaLokasi",
            label: "Locator",
            options: {
                sort: false,
            },
        },
        {
            name: "rfs",
            label: "QTY RFS",
            options: {
                sort: false,
            },
        },
        {
            name: "nonRfs",
            label: "QTY NRFS",
            options: {
                sort: false,
            },
        },
    ],
}